// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"224":"e4268a1a","237":"aad42943","335":"f5371f17","453":"c4eb7e8d","522":"8f9bdd41","638":"16bd349b","722":"99c4860c","813":"65bb633f","914":"ed218a3e"}[chunkId] + ".chunk.js";
};